"use strict";

require("core-js/modules/es.object.values");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _spaceVariants = _interopRequireDefault(require("./spaceVariants"));

var _responsiveVariantVal, _variants, _variants2, _variants3, _variants4, _variants5, _variants6;

var responsiveVariantValues = (_responsiveVariantVal = {}, _responsiveVariantVal[_spaceVariants.default.COMPACT] = {
  px: [.5, .5, .5, 1, 1.5, 1.5],
  py: [.5, .5, .5, 1, 1.5, 1.5]
}, _responsiveVariantVal[_spaceVariants.default.NORMAL] = {
  px: [1, 1, 1, 1.5, 2, 2],
  py: [1, 1, 1, 1.5, 2, 2]
}, _responsiveVariantVal[_spaceVariants.default.COMFORT] = {
  px: [1.5, 1.5, 1.5, 2, 2.5, 2.5],
  py: [1.5, 1.5, 1.5, 2, 2.5, 2.5]
}, _responsiveVariantVal);
var padding = (0, _styledSystem.variant)({
  prop: "pv",
  variants: responsiveVariantValues
});
padding.propTypes = {
  pv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingX = (0, _styledSystem.variant)({
  prop: "pxv",
  variants: (_variants = {}, _variants[_spaceVariants.default.COMPACT] = {
    px: responsiveVariantValues[_spaceVariants.default.COMPACT].px
  }, _variants[_spaceVariants.default.NORMAL] = {
    px: responsiveVariantValues[_spaceVariants.default.NORMAL].px
  }, _variants[_spaceVariants.default.COMFORT] = {
    px: responsiveVariantValues[_spaceVariants.default.COMFORT].px
  }, _variants)
});
paddingX.propTypes = {
  pxv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingL = (0, _styledSystem.variant)({
  prop: "plv",
  variants: (_variants2 = {}, _variants2[_spaceVariants.default.COMPACT] = {
    pl: responsiveVariantValues[_spaceVariants.default.COMPACT].px
  }, _variants2[_spaceVariants.default.NORMAL] = {
    pl: responsiveVariantValues[_spaceVariants.default.NORMAL].px
  }, _variants2[_spaceVariants.default.COMFORT] = {
    pl: responsiveVariantValues[_spaceVariants.default.COMFORT].px
  }, _variants2)
});
paddingL.propTypes = {
  plv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingR = (0, _styledSystem.variant)({
  prop: "prv",
  variants: (_variants3 = {}, _variants3[_spaceVariants.default.COMPACT] = {
    pr: responsiveVariantValues[_spaceVariants.default.COMPACT].px
  }, _variants3[_spaceVariants.default.NORMAL] = {
    pr: responsiveVariantValues[_spaceVariants.default.NORMAL].px
  }, _variants3[_spaceVariants.default.COMFORT] = {
    pr: responsiveVariantValues[_spaceVariants.default.COMFORT].px
  }, _variants3)
});
paddingR.propTypes = {
  prv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingY = (0, _styledSystem.variant)({
  prop: "pyv",
  variants: (_variants4 = {}, _variants4[_spaceVariants.default.COMPACT] = {
    py: responsiveVariantValues[_spaceVariants.default.COMPACT].py
  }, _variants4[_spaceVariants.default.NORMAL] = {
    py: responsiveVariantValues[_spaceVariants.default.NORMAL].py
  }, _variants4[_spaceVariants.default.COMFORT] = {
    py: responsiveVariantValues[_spaceVariants.default.COMFORT].py
  }, _variants4)
});
paddingY.propTypes = {
  pyv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingT = (0, _styledSystem.variant)({
  prop: "ptv",
  variants: (_variants5 = {}, _variants5[_spaceVariants.default.COMPACT] = {
    pt: responsiveVariantValues[_spaceVariants.default.COMPACT].py
  }, _variants5[_spaceVariants.default.NORMAL] = {
    pt: responsiveVariantValues[_spaceVariants.default.NORMAL].py
  }, _variants5[_spaceVariants.default.COMFORT] = {
    pt: responsiveVariantValues[_spaceVariants.default.COMFORT].py
  }, _variants5)
});
paddingT.propTypes = {
  ptv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var paddingB = (0, _styledSystem.variant)({
  prop: "pbv",
  variants: (_variants6 = {}, _variants6[_spaceVariants.default.COMPACT] = {
    pb: responsiveVariantValues[_spaceVariants.default.COMPACT].py
  }, _variants6[_spaceVariants.default.NORMAL] = {
    pb: responsiveVariantValues[_spaceVariants.default.NORMAL].py
  }, _variants6[_spaceVariants.default.COMFORT] = {
    pb: responsiveVariantValues[_spaceVariants.default.COMFORT].py
  }, _variants6)
});
paddingB.propTypes = {
  pbv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};

var _default = (0, _styledSystem.compose)(padding, paddingX, paddingY, paddingT, paddingR, paddingB, paddingL);

exports.default = _default;